import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const AttributesHome = () => import('./Index.vue');
// Visibility rules for the attributes listed on the page above. Sibling route so
// whoever created a field finds its permissions right next to it.
const AttributePermissions = () => import('./PermissionsView.vue');
const AiTaggingView = () => import('./AiTaggingView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'custom_attributes_list',
          component: AttributesHome,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'permissions',
          name: 'custom_attributes_permissions',
          component: AttributePermissions,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'ai-tagging',
          name: 'custom_attributes_ai_tagging',
          component: AiTaggingView,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
